import React from 'react'
import { Translation } from '@morningtrain/react-translations'
import { Link } from '@morningtrain/react-navigation'
import { Button } from 'ui'

export default function CreateOnboardingTemplateButton () {
  return (
    <Link route='app.onboarding.template'>
      <Button>
        <Translation name={'create'}/>
      </Button>
    </Link>
  )
}
